import AuthApi from '@/api/auth';
import AdminApi from '@/api/admin';

export default {
  namespaced: true,
  state: {
    allUsers: [],
    allPrograms: [],
  },
  mutations: {
    SET_ALL_USERS(state, val) {
      state.allUsers = val;
    },
    SET_ALL_PROGRAMS(state, val) {
      state.allPrograms = val;
    },

  },
  actions: {
    async getAllUsers({ commit }) {
      // eslint-disable-next-line no-useless-catch
      try {
        const allUsers = await AuthApi.getUsers();
        commit('SET_ALL_USERS', allUsers.data);
      } catch (e) {
        throw e;
      }
    },

    async registerTeacher({ dispatch }, id) {
      // eslint-disable-next-line no-useless-catch
      try {
        const teacher = await AuthApi.registerTeacher({ id });
        dispatch('getAllUsers');
        return teacher;
      } catch (e) {
        throw e;
      }
    },

    async getAllPrograms({ commit }) {
      try {
        const allPrograms = await AdminApi.getAllPrograms();
        if (allPrograms.status === 200) {
          commit('SET_ALL_PROGRAMS', allPrograms.data);
        }
      } catch (e) {
        console.log('error');
        throw e;
      }
    },

    async transferMoneyToUser({ commit }, data) {
      try {
        const transferredMoney = await AdminApi.transferMoneyToUser(data);
        if (transferredMoney.status === 200) {
          return transferredMoney;
        }
      } catch (e) {
        console.log('error');
        throw e;
      }
    },


  },
};
